"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Gallery = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("./galleries/horizontal/index.js");
var _index2 = require("./galleries/drawer/index.js");
var _smoothScroll = require("./galleries/smooth-scroll");
var _overlay = require("./galleries/overlay");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Gallery = ({
  items,
  galleryType,
  scrollContainerId,
  initTimelines,
  enableAnimation,
  setAnimationDuration,
  staticImage,
  staticPosition,
  overlayVertical,
  overlayHorizontal,
  overlayAlignment,
  fullHeight,
  imagePadding
}) => {
  const getGalleryComponent = () => {
    let C;
    switch (galleryType) {
      case 'drawer':
        C = _index2.Drawer;
        break;
      case 'smooth-scroll':
        C = _smoothScroll.SmoothScroll;
        break;
      case 'overlay':
        C = _overlay.Overlay;
        break;
      case 'horizontal':
        C = _index.Horizontal;
        break;
      default:
        C = _index.Horizontal;
        break;
    }
    return C;
  };
  const GalleryComponent = getGalleryComponent();
  return _react.default.createElement(GalleryComponent, _extends({
    items: items,
    initTimelines: initTimelines,
    scrollContainerId: scrollContainerId,
    enableAnimation: enableAnimation,
    setAnimationDuration: setAnimationDuration,
    fullHeight: fullHeight,
    imagePadding: imagePadding
  }, galleryType === 'overlay' && {
    staticImage: staticImage,
    staticPosition: staticPosition,
    overlayHorizontal: overlayHorizontal,
    overlayVertical: overlayVertical,
    overlayAlignment: overlayAlignment
  }));
};
exports.Gallery = Gallery;
//# sourceMappingURL=index.js.map